// extracted by mini-css-extract-plugin
export default {"base":"user-image-input_base__VQLdi","mask":"user-image-input_mask__Epx4W","image":"user-image-input_image__r29U6"};